export const useSparrowProductionUrl = 'true';
export const timeoutInMinutes = 5;